<template>
    
    <div class="dialog-shade-mod-point">

        <div class="update-dialog-mod-point">
            <p>{{value}}</p>
            <button id="cancle-button" v-on:click="cancleUpdate" class="ui-button primary-button short-button">{{ $t('dialog.ok') }}</button>
        </div>

    </div>

</template>

<script>
export default {

    props: {

        value: {

            type: String,
            default: ''

        }

    },

    methods: {

        cancleUpdate () {

            this.$emit( 'pointAction', false );

        }

    }
  
};

</script>

<style>

    .dialog-shade-mod-point{
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: rgba(0, 0, 0, .6);
        z-index: 8;
    }

    .update-dialog-mod-point{
        padding: .92rem 0.78rem .78rem;
        width: 5.66rem;
        box-sizing: border-box;
        text-align: center;
        transform: translate(-50%,-50%);
        top: 50%;
        left: 50%;
        background-color: #fff;
        border-radius: .2rem;
        position: fixed;
    }

    .update-dialog-mod-point p{
        color: #333;
        font-weight: 500;
        font-size: .3rem;
        margin-bottom: .4rem;
    }

</style>



// WEBPACK FOOTER //
// src/basic/pointDialog.vue